import { defineStore } from 'pinia'
import defaultTranslations from './translations.json';

export const useTextsStore = defineStore('texts', {
  state: () => ({
    texts: { ...defaultTranslations },
  }),

  getters: {
    getText: (state) => (key) => {
      return state.texts[key] || key;
    },
  },
})
